import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTypingAnimation } from '../../../hooks/useTypingAnimation';
import {
  AnimatedText,
  BottomRow,
  ContentContainer,
  IconWrap,
  ProgressWrap,
  Root,
  Row,
  StyledLinearProgress,
  StyledCloudUploadIcon,
  Title,
} from './LinearFileUpload.styles';
const LinearFileUpload: React.FC = (): JSX.Element => {
  const { t } = useTranslation('optimizer');
  const typeText = t('upload.analyzing');
  const typingSpeed = 50; 
  const pauseAfterTyped = 3000; 
  const pauseAfterDelete = 400; 
  const { displayed } = useTypingAnimation({
    typeText,
    typingSpeed,
    pauseAfterTyped,
    pauseAfterDelete,
  });
  return (
    <Root>
      <Row>
        <IconWrap>
          <StyledCloudUploadIcon />
        </IconWrap>
        <ContentContainer>
          <Title variant="body1">{t('upload.uploading')}</Title>
          <ProgressWrap>
            <StyledLinearProgress variant="indeterminate" />
          </ProgressWrap>
        </ContentContainer>
      </Row>
      <BottomRow>
        <AnimatedText variant="body2">{displayed}</AnimatedText>
      </BottomRow>
    </Root>
  );
};
export default LinearFileUpload;
